import { RouteConfig } from "vue-router";
import { RTasksBrowse } from "@/modules/Tasks/Browse/RTasksBrowse";
import { RTasksTemplate } from "@/modules/Tasks/Template/RTasksTemplate";

export const RCompanyTasks: RouteConfig = {
  path: "tasks",
  component: () =>
    import(
      /* webpackChunkName: "companies-template-company-tasks" */
      "./VCompanyTasks.vue"
    ),
  meta: {
    label: "tasks",
    title: "Companies",
  },
  children: [RTasksBrowse, RTasksTemplate],
};
